<template>
    <div class="navigation">
        <!-- Navigation -->
        <nav class="navbar navbar-expand-lg navbar-dark fixed-top" id="logoNav">
             <div class="container">
                <router-link class="navbar-brand js-scroll-trigger" to="/"><img :src="logo" alt="" /></router-link>
             </div>
        </nav>
    </div>
</template>
<script>

export default {
  name: 'LogoNav',
  components: {
  },
  props: {
  },
  data() {
    return {
      logo: "img/" + process.env.VUE_APP_BRAND + "/nav_logo.png"
    }
  },
  mounted() {
  
  },
  destroyed() {
   
  },
  methods: {
  }
}
</script>